import { Component, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { GenericBulkUpsertLandingComponent } from '../../shared/containers/generic-bulk-upsert-landing.component';
import { GenericBulkUpsertService } from '../../shared/services/generic-bulk-upsert.service';
import { RATE_PACKAGE_BULK_UPSERT_FIELDS } from '../models/rate-package-bulk-upsert.model';
import { GenericBulkUpsertFeatureState } from '../../shared/store';

@Component({
  selector: 'rate-package-bulk-upsert-landing',
  templateUrl: '../../shared/containers/generic-bulk-upsert-landing.component.html'
})
export class RatePackageBulkUpsertLandingComponent extends GenericBulkUpsertLandingComponent {
  title = 'Rate Package';
  validateEndpoint = 'api/rentalpackage/bulk/validate';
  uploadEndpoint = 'api/rentalpackage/bulk/upload';
  fields = RATE_PACKAGE_BULK_UPSERT_FIELDS;
  templateFilename = 'rate-package_bulk_upsert_template.csv';

  constructor(
    protected store: Store<GenericBulkUpsertFeatureState>, 
    protected cdr: ChangeDetectorRef,
    protected genericService: GenericBulkUpsertService
  ) {
    super(store, cdr, genericService);
  }
}
